import * as request from 'requestES';

export const doReserve = function (data) {
  const url = `//eventsapi.gm99.com/activity/execute?name=bxjxyy&action=do_reserve`;
  return request.ajax({
    url,
    data,
  });
};

export const getReserveInfo = function (data) {
  const url = `//eventsapi.gm99.com/activity/execute?name=bxjxyy_phone&action=get_base_info`;
  return request.ajax({
    url,
    data,
  });
};

export const joinGroup = function (data) {
  const url = `//eventsapi.gm99.com/activity/execute?name=bxjxyy&action=joinGroup`;
  return request.ajax({
    url,
    data,
  });
};

export const createGroup = function (data) {
  const url = `//eventsapi.gm99.com/activity/execute?name=bxjxyy&action=createGroup`;
  return request.ajax({
    url,
    data,
  });
};

export const myGroup = function (data) {
  const url = `//eventsapi.gm99.com/activity/execute?name=bxjxyy&action=myGroup`;
  return request.ajax({
    url,
    data,
  });
};

export const groupDetail = function (data) {
  const url = `//eventsapi.gm99.com/activity/execute?name=bxjxyy&action=groupDetail`;
  return request.ajax({
    url,
    data,
  });
};

export const groupList = function (data) {
  const url = `//eventsapi.gm99.com/activity/execute?name=bxjxyy&action=groupList`;
  return request.ajax({
    url,
    data,
  });
};

export const groupAward = function (data) {
  const url = `//eventsapi.gm99.com/activity/execute?name=bxjxyy&action=groupAward`;
  return request.ajax({
    url,
    data,
  });
};

export const awardLog = function (data) {
  const url = `//eventsapi.gm99.com/activity/execute?name=bxjxyy&action=awardLog`;
  return request.ajax({
    url,
    data,
  });
};

export const editLine = function (data) {
  const url = `//eventsapi.gm99.com/activity/execute?name=bxjxyy&action=editLine`;
  return request.ajax({
    url,
    data,
  });
};
